var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.hideYesterday
        ? [
            _c(
              "div",
              [
                _c("p", [
                  _vm._v("\n          за "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.moment(_vm.balance.start_date, "DD.MM.YYYY"))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm._l(_vm.balance.start, function (bal, curr) {
                  return bal.orders
                    ? [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$AllCurrencies[curr].currency) +
                              ":\n            "
                          ),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                (
                                  bal.orders -
                                  (+curr === 33 ? _vm.totalNoCashStart : 0)
                                ).toLocaleString("ru-RU")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.currentCurrencyId !== 33
                            ? _c("span", [
                                _vm._v(
                                  " (RUB: " +
                                    _vm._s(
                                      _vm
                                        .getCalculatedAmount(
                                          _vm.balance.start[
                                            _vm.currentCurrencyId
                                          ]?.orders ?? 0
                                        )
                                        .toLocaleString("ru-RU")
                                    ) +
                                    ")"
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    : _vm._e()
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("hr"),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n      за "),
        _c("strong", [
          _vm._v(_vm._s(_vm.moment(_vm.currentDate, "DD.MM.YYYY"))),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.reportCurrencies, function (currencyId, i) {
        return _c(
          "div",
          { key: currencyId },
          [
            _vm.reportCurrencies.length > 1
              ? _c("p", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$AllCurrencies[currencyId]?.currency)),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n        Сальдо прошлого дня::\n        "),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.currentCurrencyId === +currencyId
                      ? (
                          (_vm.balance.start[_vm.currentCurrencyId]?.orders ??
                            0) - _vm.totalNoCashStart
                        ).toLocaleString("ru-RU")
                      : _vm
                          .getCalculatedAmount(
                            (_vm.balance.start[_vm.currentCurrencyId]?.orders ??
                              0) - _vm.totalNoCashStart
                          )
                          .toLocaleString("ru-RU")
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.expenses && _vm.expenses.length
              ? [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("p", [
                        _vm._v("\n            Расходы:\n            "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm
                                .getTotalAmount("expenses", currencyId)
                                .toLocaleString("ru-RU")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-popover",
                        {
                          staticClass: "d-inline",
                          attrs: {
                            placement: "bottom",
                            "auto-hide": true,
                            trigger: "manual",
                            open: _vm.detailedExpenses,
                          },
                        },
                        [
                          _c("i", {
                            staticClass:
                              "p-l-5 icon-fa icon-fa-info-circle expenses_tooltip_fa",
                            on: {
                              click: function ($event) {
                                _vm.detailedExpenses = !_vm.detailedExpenses
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "template",
                            { slot: "popover" },
                            _vm._l(_vm.expenses, function (exps) {
                              return _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$AllCurrencies[exps.currency_id]
                                        .currency
                                    ) +
                                    ":\n                "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(exps.sum.toLocaleString("ru-RU"))
                                  ),
                                ]),
                                _vm._v(" "),
                                exps.comment
                                  ? _c("span", [
                                      _vm._v("(" + _vm._s(exps.comment) + ")"),
                                    ])
                                  : _vm._e(),
                              ])
                            }),
                            0
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.incomes && _vm.incomes.length
              ? _c(
                  "div",
                  [
                    _vm.getIncomes("income", true)
                      ? [
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n              Входящие инкассации:\n              "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm
                                        .getIncomes(
                                          "income",
                                          false,
                                          true,
                                          +currencyId
                                        )
                                        .toLocaleString("ru-RU")
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-popover",
                                {
                                  staticClass: "d-inline",
                                  attrs: {
                                    placement: "bottom",
                                    "auto-hide": true,
                                    trigger: "manual",
                                    open: _vm.detailedIncomesIn,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "p-l-5 icon-fa icon-fa-info-circle expenses_tooltip_fa",
                                    on: {
                                      click: function ($event) {
                                        _vm.detailedIncomesIn =
                                          !_vm.detailedIncomesIn
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "template",
                                    { slot: "popover" },
                                    _vm._l(
                                      _vm.getIncomes("income"),
                                      function (exps) {
                                        return _c("p", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$AllCurrencies[
                                                  exps.currency_id
                                                ].currency
                                              ) +
                                              ":\n                  "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                exps.sum.toLocaleString("ru-RU")
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          exps.comment
                                            ? _c("span", [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(exps.comment) +
                                                    ")"
                                                ),
                                              ])
                                            : _vm._e(),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.getIncomes("outCome", true)
                      ? [
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n              Исходящие инкассации:\n              "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm
                                        .getIncomes(
                                          "outCome",
                                          false,
                                          true,
                                          +currencyId
                                        )
                                        .toLocaleString("ru-RU")
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-popover",
                                {
                                  staticClass: "d-inline",
                                  attrs: {
                                    placement: "bottom",
                                    "auto-hide": true,
                                    trigger: "manual",
                                    open: _vm.detailedIncomesOut,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "p-l-5 icon-fa icon-fa-info-circle expenses_tooltip_fa",
                                    on: {
                                      click: function ($event) {
                                        _vm.detailedIncomesOut =
                                          !_vm.detailedIncomesOut
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "template",
                                    { slot: "popover" },
                                    _vm._l(
                                      _vm.getIncomes(
                                        "outCome",
                                        false,
                                        false,
                                        +currencyId
                                      ),
                                      function (exps) {
                                        return _c("p", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$AllCurrencies[
                                                  exps.currency_id
                                                ].currency
                                              ) +
                                              ":\n                  "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                exps.sum.toLocaleString("ru-RU")
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          exps.comment
                                            ? _c("span", [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(exps.comment) +
                                                    ")"
                                                ),
                                              ])
                                            : _vm._e(),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.cardsCashOut
              ? [
                  _c("p", [
                    _vm._v("Обналичивание доставочных карт:\n          "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.cardsCashOut.toLocaleString("ru-RU"))),
                    ]),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.exchanges.length
              ? _c("p", [
                  _vm._v("\n        Покупка валюты: "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.totalFigures.exchanges.toLocaleString("ru-RU"))
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.orders?.total_pass ?? 0
              ? _c(
                  "p",
                  [
                    _vm._v(
                      "\n        Сумма по сегодняшним заявкам (с вычетом зарплаты):\n        "
                    ),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          (+currencyId !== 33
                            ? _vm.orders.total_currency_clear_price ?? 0
                            : _vm.orders?.total_pass ?? 0
                          ).toLocaleString("ru-RU")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.totalNoCashEnd
                      ? [
                          _c("span", [
                            _vm._v(" - "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.totalNoCashEnd.toLocaleString("ru-RU")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "underline" }, [
                              _vm._v("(расчет по без.нал.) = "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    (
                                      (_vm.orders?.total_pass ?? 0) -
                                      _vm.totalNoCashEnd
                                    ).toLocaleString("ru-RU")
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n        ИТОГО:\n        "),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    (_vm.currentCurrencyId === +currencyId
                      ? (_vm.balance.start[_vm.currentCurrencyId]?.orders ??
                          0) - _vm.totalNoCashStart
                      : _vm.getCalculatedAmount(
                          (_vm.balance.start[_vm.currentCurrencyId]?.orders ??
                            0) - _vm.totalNoCashStart
                        )
                    ).toLocaleString("ru-RU")
                  ) +
                    " -\n          " +
                    _vm._s(
                      _vm
                        .getTotalAmount("expenses", currencyId)
                        .toLocaleString("ru-RU")
                    ) +
                    " -\n          "
                ),
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm
                        .getIncomes("outCome", false, true, +currencyId)
                        .toLocaleString("ru-RU")
                    ) +
                    " +\n"
                ),
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm
                        .getIncomes("income", false, true, +currencyId)
                        .toLocaleString("ru-RU")
                    ) +
                    " +\n          " +
                    _vm._s(_vm.cardsCashOut.toLocaleString("ru-RU")) +
                    " +\n          " +
                    _vm._s(
                      (+currencyId !== 33
                        ? (_vm.orders?.total_currency_clear_price ?? 0) -
                          _vm.totalNoCashEnd
                        : (_vm.orders?.total_pass ?? 0) - _vm.totalNoCashEnd
                      ).toLocaleString("ru-RU")
                    ) +
                    " -\n          " +
                    _vm._s(_vm.totalFigures.exchanges.toLocaleString("ru-RU")) +
                    "\n        "
                ),
              ]),
              _vm._v("\n        =\n        "),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.getTotalDayOffSum(currencyId).toLocaleString("ru-RU")
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("hr"),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }